import { createContext, useContext } from "react";
import { MeiliSearch } from "meilisearch";
import { AppConfig } from "../utils/config";

export const searchClient = new MeiliSearch({
  host: AppConfig.meilisearchHost,
  apiKey: AppConfig.meilisearchApiKey,
});

export const SearchContext = createContext(searchClient);

export const useSearch = () => {
  const client = useContext(SearchContext);
  return client;
};
